<script setup>
import {computed, onMounted, ref} from 'vue'
import api from '@/services/api'
import {usePageSectionsStore} from '@/stores/pageSections'

const props = defineProps({
    sectionId: Number
})

const pageSectionsStore = usePageSectionsStore()

const section = computed(() => pageSectionsStore.items?.find(o => o.id === props.sectionId))

const pageSectionTemplates = ref([])

onMounted(async () => {
    try {
        const response = await api.get('api/component/templates_templates', {
            params: {type: 'container', sort: 'title'}
        })
        pageSectionTemplates.value = response?.data?.items || []
    } catch (error) {
        console.error('Failed to load container templates:', error)
        pageSectionTemplates.value = []
    }
})

const savePageContainerId = async (e) => {
    const pageContainerId = parseInt(e.target.value)

    await api.post(`api/page-section/${props.sectionId}`, {pageContainerId})

    await pageSectionsStore.init(true)
}
</script>

<template>
    <div>
        <label class="d-block mb-1 small">Container</label>
        <select @change="savePageContainerId" class="form-select form-select-sm w-auto">
            <option value="" selected disabled>Select&hellip;</option>
            <option v-for="o in pageSectionTemplates" :key="o.id" :value="o.id"
                    :selected="o.id === section?.pageContainerId">
                {{ o.title }}
            </option>
        </select>
    </div>
</template>